// tslint:disable-next-line: no-namespace
export namespace PropertyLookup {
  export function getPropArray<T = string>(obj: object, prop: string): T[] {
    return obj != null && obj[prop] != null ? (Array.isArray(obj[prop]) ? obj[prop] : [obj[prop]]) : [];
  }

  export function getPropArrayOrUndefined<T = string>(obj: object, prop: string): T[] | undefined {
    return obj != null && obj[prop] != null ? (Array.isArray(obj[prop]) ? obj[prop] : [obj[prop]]) : undefined;
  }

  export function getSortedPropArray(obj: object, prop: string): string[] {
    const propValue = obj && obj[prop];
    return Array.isArray(propValue) ? propValue.sort((a, b) => parseInt(a, 10) - parseInt(b, 10)) : [];
  }

  export function getSingleProp<T = string | null>(obj: object | null, prop: string): T {
    if (obj && Array.isArray(obj[prop]) && obj[prop].length !== 1) {
      throw new Error(`Invalid property: ${prop}: ${JSON.stringify(obj)}`);
    }

    return obj && obj[prop] ? (Array.isArray(obj[prop]) ? obj[prop][0] : obj[prop]) : (null as T);
  }

  export function getSingleNum(obj: object, prop: string): number | null {
    return parseInt(getSingleProp(obj, prop) as string, 10) || null;
  }

  export function getNumArray(obj: object, prop: string): number[] {
    return obj && obj[prop] ? obj[prop].map((n) => parseInt(n, 10)) : [];
  }
}
